import { useContext } from 'react'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { toastSuccess } from '../../../../utils/toast'
import Tooltip from '../../../Utilities/Tooltip'

const WelcomeText = () => {
  const { [SETTINGS.WELCOME_TEXT.key]: welcomeText, updateSetting } =
    useContext(SiteConfigContext)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const data = formData.get('welcometext')
    await updateSetting(SETTINGS.WELCOME_TEXT, data)
    toastSuccess('Welcome Text saved.')
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center">
        <h2 className="mr-3">Welcome Text</h2>
        <Tooltip>
          Customize the welcome message that greets users when they visit your
          site. You can also upload a video in the Assets tab for added
          personalization.
        </Tooltip>
      </div>
      <span className="dark:text-neutral-100">
        A video may also be uploaded in the Assets tab.
      </span>
      <form
        onSubmit={(e) => handleSubmit(e)}
        autoComplete="off"
        className="flex gap-2"
      >
        <textarea
          aria-label="Input poll prompt"
          id="welcometext"
          name="welcometext"
          className="grow input w-full"
          placeholder="Enter welcome text..."
          defaultValue={welcomeText}
        />
        <button
          type="submit"
          aria-label="Save Welcome Text"
          className="button-confirm w-fit"
        >
          Save
        </button>
      </form>
    </div>
  )
}

export default WelcomeText
